/**
 * Redirect legacy HashRouter bookmarks (`/#/path`) to clean BrowserRouter paths
 * (`/path`) before React mounts. Returns true when a redirect was applied.
 */
export function redirectLegacyHashRoute(
  href: string = typeof window !== "undefined" ? window.location.href : "",
): boolean {
  if (typeof window === "undefined") return false;
  try {
    const url = new URL(href);
    const raw = url.hash;
    if (!raw.startsWith("#/")) return false;

    const withoutHash = raw.slice(1); // /path?query
    const qIndex = withoutHash.indexOf("?");
    const path = qIndex >= 0 ? withoutHash.slice(0, qIndex) : withoutHash;
    const hashQuery = qIndex >= 0 ? withoutHash.slice(qIndex) : "";
    // Prefer query embedded in the hash (legacy HashRouter style).
    const search = hashQuery || url.search || "";
    const next = path + search;
    window.history.replaceState(null, "", next);
    return true;
  } catch {
    return false;
  }
}
